import { render, staticRenderFns } from "./UserDialogDataTabComponent.vue?vue&type=template&id=26ae0787&scoped=true"
import script from "./UserDialogDataTabComponent.js?vue&type=script&lang=js&external"
export * from "./UserDialogDataTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./UserDialogDataTabComponent.vue?vue&type=style&index=0&id=26ae0787&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ae0787",
  null
  
)

export default component.exports